import React, { useEffect, useState } from "react";
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import TelegramIcon from '@mui/icons-material/Telegram';
import TwitterIcon from '@mui/icons-material/Twitter';
import MailIcon from '@mui/icons-material/Mail';
import MailchimpFormContainer from "../../MailChimp/MailChimpForm";
import QuizIcon from '@mui/icons-material/Quiz';
import router from "next/router";

//
const MyMenu = styled(Menu)({
    ".MuiMenu-paper": {
        background: "#292c2e",
        color: "white",
        "& li": {
            transition: "all .1s linear",
            fontWeight: 700,
            fontSize: "14px",
            padding: "8px 25px 8px 25px",
            "&:hover": {
                //transform: "scale(1.1, 1.1)",
                background: "#383d40"
            }
        }
    }
});

// Component
function CommunityMenu(props: any) {

    const [openJoinEmailModal, setOpenJoinEmailModal] = useState(false);

    function joinEmailModalOpenhandler(e: any) {
        setOpenJoinEmailModal(true);
        setTimeout(() => { setOpenJoinEmailModal(false) }, 1000);
        //props.handleClose(e, null);
    }

    function questsHandler(e: any) {
        router.push("/quests");
        props.handleClose(e);
    }

    return (
        <Box>
            <MyMenu
                id="community-menu"
                anchorEl={props.anchorEl}
                open={props.open}
                onClose={props.handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: props.horizontal,
                }}>

                <MenuItem onClick={(e) => props.handleClose(e, 'discord')}><img src="/Discord-Logo-White.svg" style={{ width: "25px", marginRight: "10px" }} />
                    Discord
                </MenuItem>

                <MenuItem onClick={(e) => props.handleClose(e, 'twitter')}><TwitterIcon sx={{ color: "white", marginRight: "11px" }} />
                    Twitter
                </MenuItem>

                <MenuItem onClick={(e) => props.handleClose(e, 'medium')}><img src="/medium-logo.png" style={{ width: "25px", marginRight: "10px" }} />
                    Medium
                </MenuItem>

                <MenuItem onClick={(e) => joinEmailModalOpenhandler(e)}><MailIcon sx={{ color: "white", marginRight: "11px" }} />
                    Join Email List
                </MenuItem>

                <MenuItem onClick={(e) => questsHandler(e)}><QuizIcon sx={{ color: "white", marginRight: "11px" }} />
                    Quests
                </MenuItem>
            </MyMenu>

            <MailchimpFormContainer autoCloseOnSuccess={false} updateQuests={() => { }} showJoinBtn={false} open={openJoinEmailModal} />
        </Box>
    );
}

// Default style!
const CommunityMenuStyled = styled(CommunityMenu)({

});

// Export
export default CommunityMenuStyled;
